import {
  SIDE_NAV_LIGHT,
  NAV_TYPE_SIDE,
  DIR_LTR,
} from "constants/ThemeConstant";
import { api } from "./ApiConfig";

export const VersionNumber = "7.5.6";
export const BearerToken = localStorage.getItem("BearerToken");
export const RefreshToken = localStorage.getItem("RefreshToken");
export const GetDealCode = localStorage.getItem("dialCode");
export const RefreshTimestamp = new Date(
  localStorage.getItem("RefreshTimestamp"),
);
export const APP_NAME = "Accrue";
export const API_BASE_URL = api.API_ENDPOINT_URL;
export const BaseURL2 = api.API_SWAGGER;
export const BaseUrlIncentive = api.API_SWAGGER_INCENTIVE;
export const BaseUrlAttendance = api.API_SWAGGER_ATTENDANCE;
export const BaseUrlChecklists = api.API_SWAGGER_CHECKLISTS;
export const BaseUrlAssetManager = api.API_ASSET_MANAGER;
export const BaseUrlServiceDesk = api.API_SERVICEDESK;
export const BaseURLELearningService = api.API_SWAGGER_E_LESARNING_SERVICE;
export const BaseURLCopilotService = api.API_COPILOT_SERVICE;
export const BaseURL = api.API_ENDPOINT_URL;
export const AwsBucket = api.AwsBucket;
export const CloudFrontUrl = api.CloudFrontUrl;
export const AwsUploadFiles = api.API_AWS_FILE_UPLOAD;
export const EmployeeID = localStorage.getItem("EmployeeID");
export const CompanyID = localStorage.getItem("CompanyID");
export const Permissions = JSON.parse(localStorage.getItem("Permissions"));
export const LoggedInState = JSON.parse(localStorage.getItem("LoggedIn"));
export const Headers = {
  Authorization: `Bearer ${BearerToken}`,
  Accept: "application/json",
  "Accrue-Client": "AdminPanel",
};
export const FirstName = localStorage.getItem("FirstName");
export const LastName = localStorage.getItem("LastName");
export const Image = localStorage.getItem("Image");
export const ReadServices = localStorage.getItem("ReadServices");
export const WriteServices = localStorage.getItem("WriteServices");
export const EmployeeCode = localStorage.getItem("EmployeeCode");
export const APP_PREFIX_PATH = "/app";
export const AUTH_PREFIX_PATH = "/auth";
export const Infinx_CompanyID = "30a95dc2-8fff-4454-b686-6c44da760929";
export const WEB_APP_URL = api.WEB_APP_URL;

export const THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: SIDE_NAV_LIGHT,
  locale: "en",
  navType: NAV_TYPE_SIDE,
  topNavColor: "#3e82f7",
  headerNavColor: "",
  mobileNav: false,
  currentTheme: "light",
  direction: DIR_LTR,
};
